import cn from 'classnames';
import { pathgen } from 'object-path-generator';
import { Column, Divider, FullBox, Typography } from 'seagull';
import { useCobConfig } from "../CobConfigContext";
import { useResponsive } from "../../contexts";
import SignedAgreementAnimationWrapper from "../SignedAgreementAnimationWrapper/SignedAgreementAnimationWrapper";
import styles from "./PendingAdditionalSignaturesWithAnimations.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PendingAdditionalSignaturesWithAnimationsDataTestIds = pathgen('PendingAdditionalSignaturesWithAnimationsDataTestIds');
const RecipientRow = _ref => {
  let {
    firstName,
    lastName,
    email,
    testId
  } = _ref;
  const {
    isDesktop
  } = useResponsive();
  return /*#__PURE__*/_jsxs(FullBox, {
    className: styles.recipientsSectionRow,
    flexDirection: isDesktop ? 'row' : 'column',
    children: [/*#__PURE__*/_jsx(Typography, {
      weight: "normal",
      variant: "paragraph1",
      testId: "".concat(testId, "-name"),
      children: "".concat(firstName || '', " ").concat(lastName || '')
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph1",
      skin: "secondary",
      testId: "".concat(testId, "-email"),
      children: email
    })]
  });
};
const PendingAdditionalSignaturesWithAnimations = () => {
  var _relationship$signato;
  const {
    relationship
  } = useCobConfig();
  const {
    isDesktop
  } = useResponsive();
  const {
    email,
    lastName,
    firstName
  } = relationship.buyer;
  const hasPrimarySignatorySigned = relationship.approvalRecord !== null;
  return /*#__PURE__*/_jsx(SignedAgreementAnimationWrapper, {
    testId: PendingAdditionalSignaturesWithAnimationsDataTestIds.Root(),
    children: /*#__PURE__*/_jsxs(Column, {
      className: cn(styles.thankYouSectionWrapper, {
        [styles.desktop]: isDesktop,
        [styles.mobile]: !isDesktop
      }),
      children: [/*#__PURE__*/_jsxs(Column, {
        className: styles.thankYouSection,
        testId: PendingAdditionalSignaturesWithAnimationsDataTestIds.ThankYouSection(),
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h3",
          weight: "normal",
          className: styles.thankYouText,
          children: "Thanks for signing!"
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "h6",
          children: "Pending additional signatures. A confirmation email will be sent once all signatures are collected."
        })]
      }), /*#__PURE__*/_jsx(Divider, {
        margin: isDesktop ? 24 : 16
      }), /*#__PURE__*/_jsxs(FullBox, {
        className: styles.recipientsSection,
        testId: PendingAdditionalSignaturesWithAnimationsDataTestIds.RecipientsSection(),
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "paragraph1",
          testId: PendingAdditionalSignaturesWithAnimationsDataTestIds.AwaitingRecipientsText(),
          children: "Awaiting the following recipients:"
        }), !hasPrimarySignatorySigned && /*#__PURE__*/_jsx(RecipientRow, {
          firstName: firstName,
          lastName: lastName,
          email: email,
          testId: PendingAdditionalSignaturesWithAnimationsDataTestIds.PrimarySignatory()
        }), (_relationship$signato = relationship.signatories) === null || _relationship$signato === void 0 ? void 0 : _relationship$signato.map((signatory, index) => !signatory.approvalRecord && /*#__PURE__*/_jsx(RecipientRow, {
          firstName: signatory.firstName,
          lastName: signatory.lastName,
          email: signatory.email,
          testId: PendingAdditionalSignaturesWithAnimationsDataTestIds.Signatory(index)
        }, signatory.id))]
      })]
    })
  });
};
export default PendingAdditionalSignaturesWithAnimations;